module.exports = __webpack_public_path__ + "img/rouler_positions_4_back.4fb8d61d.png";